module.exports = __webpack_public_path__ + "media/images/landing__teaser__scoring-13116501be3e9917785514f5a0032fb6.png";